import { useEffect } from 'react';

const useAppier = () => {
  useEffect(() => {
    // 初始化 appier_q
    window.appier_q = window.appier_q || [];
    window.appier_q.push(
          { t: 'register', content: { id: '95fb', site: 'yhd.tw' } },
          {
            t: 'pv_track',
            action_id: 'PageView_025f',
            track_id: '77eb0a7748bc95a',
            isCountReload: true,
            counter: 0,
          },
          {
            t: 'pv_track',
            action_id: 'ViewTwoPages_93f3',
            track_id: '77eb0a7748bc95a',
            isCountReload: false,
            counter: 1,
          }
        );

        // 動態載入 aa.js
        const script = document.createElement('script');
        script.src = '//jscdn.appier.net/aa.js?id=yhd.tw';
        script.async = true;
        document.head.appendChild(script);

        // 可選：返回 cleanup 函數移除 script
        return () => {
          document.head.removeChild(script);
        };
      }, []);
};

export default useAppier;
